import { BizProcessEntity } from '../../abstract-biz-process-entity';
import { IWritebackProcessEntity } from '../interface-writeback-process-entity';

/**
 * ååæµç¨å®ä½ç±»
 */
export class AifWritebackProcessEntity extends BizProcessEntity implements IWritebackProcessEntity {
    WritebackRuleMetadataId: string;

    WritebackRuleId: string;

}